export const CONCURSO_INIT = 'CONCURSO_INIT'
export const CONCURSO_SELECTED = 'CONCURSO_SELECTED'
export const PRETICKETS_SELECTED = 'PRETICKETS_SELECTED'
export const CONCURSOSCREEN_SELECTED = 'CONCURSOSCREEN_SELECTED'
export const DEZENA_SELECTED = 'DEZENA_SELECTED'
export const CONCURSO_DATE_SELECTED = 'CONCURSO_DATE_SELECTED'

export function init(concursoScreen){
    return {
        type: CONCURSO_INIT,
        payload: concursoScreen
    }
}

export function selectConcursoType(concursoType){
    return concursoType.isPreTicket ? {
        type: PRETICKETS_SELECTED,
        payload: concursoType
    } : {
        type: CONCURSO_SELECTED,
        payload: concursoType
    };
}

export function selectConcursoScreen(concursoScreen){
    return {
        type: CONCURSOSCREEN_SELECTED,
        payload: concursoScreen
    }
}

export function selectDezena(arrDezena){
    return  {
        type: DEZENA_SELECTED,
        payload: arrDezena
    }
}

export function selectConcursosDate(selectedConcursos){
    return  {
        type: CONCURSO_DATE_SELECTED,
        payload: selectedConcursos
    }
}



// WEBPACK FOOTER //
// ./src/reducers/concurso/concursoActions.js